var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "my-3 pa-3",
      class: { "soli-round": _vm.$vuetify.breakpoint.smAndUp },
      attrs: { flat: "" },
    },
    [
      _vm.question
        ? _c(
            "div",
            {
              staticClass:
                "pa-3 pb-2 soli-grey text-align-start font-weight-bold text-lg",
            },
            [
              _vm._t("question"),
              _vm._v(" "),
              _vm.required
                ? _c("div", { staticClass: "grey--text caption" }, [
                    _vm._v("*required"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._t("action"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "absolute right-0 my-6 py-05 mr-7 top-0" },
                [_vm._t("end")],
                2
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "pa-2 soli-grey" }, [_vm._t("response")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }